import { noop } from 'lodash';

import {
   MedicalInformation,
   MedicalInformationAttachment,
   MedicalInformationQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import {
   MarginPosition,
   Notification,
   NotificationSize,
   NotificationType,
   StandardSpinner,
} from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { visitHistoryTranslationKeys } from '../translations';

type VisitHistoryOtherExaminationAttachmentLoaderRenderProps = {
   medicalInformationAttachments: MedicalInformationAttachment[] | undefined;
};

type VisitHistoryOtherExaminationAttachmentProps = {
   readonly visitMedicalInformationId: number;
   readonly children: (renderProps: VisitHistoryOtherExaminationAttachmentLoaderRenderProps) => JSX.Element;
};

export const VisitHistoryOtherExaminationAttachmentLoader = (
   props: VisitHistoryOtherExaminationAttachmentProps
): JSX.Element => {
   const {
      data: medicalInformation,
      loading: medicalInformationLoading,
      error: medicalInformationError,
   } = useCqrsGet<MedicalInformation>(
      () => {
         const query = new MedicalInformationQuery();
         query.id = Slot.of(props.visitMedicalInformationId);
         return query;
      },
      { cacheTime: 'short', onUnexpectedError: noop }
   );

   if (medicalInformationLoading) {
      return <StandardSpinner />;
   }

   if (medicalInformationError) {
      return (
         <Notification
            testId={'noMedicalInformationDataNotification'}
            type={NotificationType.WARNING}
            size={NotificationSize.SMALLER}
            label={visitHistoryTranslationKeys.otherExaminationFetchError}
            margin={MarginPosition.TOP}
         />
      );
   }

   return props.children({
      medicalInformationAttachments: medicalInformation.attachments,
   });
};
